import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { AppLanguageCode, isAppLanguageCode } from '@project-types/AppLanguageCodes';
import { LanguageDefinition } from '@project-types/LanguageDefinitions';
import { DEFAULT_LANGUAGE, LANGUAGE_DEFINITIONS } from '@@/languageConfig';
import { resources } from '@translations/imports';



export default function loadTranslations() {
	i18next.use(initReactI18next).init({
		lng: DEFAULT_LANGUAGE,
		fallbackLng: DEFAULT_LANGUAGE,
		interpolation: {
			escapeValue: false, // React already escapes values
		},
		ns: [ 'global', 'admin', 'forms', 'links', 'web' ],
		resources: resources,
	});
};


export function addResourceBundle(language: AppLanguageCode, resource: string) {
	try {
		const parsedResource = typeof resource === 'string'
			? JSON.parse(resource)
			: resource;
	
		Object.entries(parsedResource).forEach(([namespace, content]) => {
			i18next.addResourceBundle(language, namespace, content);
		});
	} catch (error) {
		console.error('Translation Error: Resource parsing failed');
		console.error(`Details:\nEnvironment: ${process.env.ENV}\nError: ${error}`);
		return;
	}
}


export function getCurrentLanguageCode(): AppLanguageCode {
	return isAppLanguageCode(i18next.language) ? i18next.language : DEFAULT_LANGUAGE;
};


export function getLanguageTag(): string {
	const languageDef = getCurrentLanguageDefinition();
	return languageDef ? languageDef.locale : '';
};


export function getFormattedPrice(language: AppLanguageCode, price: number | null | undefined): string {
	const languageDef = getLanguageDefinition(language);
	const formattedPrice = new Intl.NumberFormat(languageDef.locale, {
		style: 'currency',
		currency: languageDef.currency,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(price ?? 0);

	return formattedPrice.replace(/([.,])00(\s*\S+)$/, '$2');
};


export function getLanguageCurrency(language: AppLanguageCode): string {
	const languageDef = getLanguageDefinition(language);
	return languageDef.currency;
};



function getCurrentLanguageDefinition(): LanguageDefinition {
	const languageCode = getCurrentLanguageCode();
	const languageDef = LANGUAGE_DEFINITIONS[languageCode];
	return languageDef ? languageDef : LANGUAGE_DEFINITIONS[DEFAULT_LANGUAGE];
};

function getLanguageDefinition(language: AppLanguageCode): LanguageDefinition {
	const languageDef = LANGUAGE_DEFINITIONS[language];
	return languageDef ? languageDef : LANGUAGE_DEFINITIONS[DEFAULT_LANGUAGE];
};